import React from "react";
import { graphql } from "gatsby";
import { OurApproachLabModeFieldsFragment } from "../../../../graphql-types";

import * as styles from "./lab-mode.module.scss"

const LabMode = ({ data }: { data: OurApproachLabModeFieldsFragment }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.visuallyHidden}>{data.titleImage?.alt || ""}</h2>
        <img src={data.titleImage?.url} alt={data.titleImage?.alt} className={styles.titleImage} />
        <p className={styles.subtitle}>{data.subtitle}</p>
        <div className={styles.axisContainer}>
          {data.axes.map((axis) => (
            <div className={styles.axis} key={axis.title}>
              <h3 className={styles.axisTitle}>{axis.title}</h3>
              <p className={styles.axisDescription}>{axis.description}</p>
            </div>
          ))}
        </div>
    </div>
  )
}

export const fragment = graphql`
  fragment OurApproachLabModeFields on DatoCmsOurApproachLabMode {
    __typename
    titleImage {
      url
      alt
      format
    }
    subtitle
    axes {
      title
      description
    }
  }
`

export default LabMode